
import store from '@/state/store'
import appConfig from "@/app.config";

export const directives = [
    {
        name: 'can',
        func: (el, binding, vnode) => {

            let permissions = Array.isArray(binding.value) ? binding.value : binding.value.split('|')
            if (!store.getters['auth/getUser'].hasAnyPermission(permissions))
                binding.arg === 'disable'? el.disabled = true : commentNode(el, vnode) 
        }
    },
    {
        name: 'canAny',
        func: (el, binding, vnode) => {
            let permissions = Array.isArray(binding.value) ? binding.value : binding.value.split('|')
            if (!store.getters['auth/getUser'].hasAnyPermission(permissions))
                binding.arg === 'disable'? el.disabled = true : commentNode(el, vnode) 
        }
    },
    {
        name: 'canAll',
        func: (el, binding, vnode) => {
            let permissions = Array.isArray(binding.value) ? binding.value : binding.value.split(',')
            if (!store.getters['auth/getUser'].hasAllPermissions(permissions))
                binding.arg === 'disable'? el.disabled = true : commentNode(el, vnode) 
        }
    },
    {
        name: 'downloadable',
        func: (el, binding) => {
            if (binding.value == null){
                el.innerText = 'لا يوجد'
                el.style.cursor = 'not-allowed';
            }
        }
    },
    {
        name: 'siteRoute',
        func: (el, binding) => {
            if (typeof binding.value == 'object' || typeof binding.value == 'string' || typeof binding.value.name == 'object'){
                el.setAttribute('href', appConfig.site.appUrl + '/' +
                            appConfig.site.endPoint[
                                typeof binding.value == 'string'? binding.value : binding.value.name
                            ] + 
                            ( typeof binding.value.param == 'object' ? '?' + new URLSearchParams(binding.value.param).toString() : '')
                )
            }
        }
    }
]


// =============
// Private helper
// =============
function commentNode(el, vnode){
    // replace HTMLElement with comment node
    const comment = document.createComment(' ');
    Object.defineProperty(comment, 'setAttribute', {
      value: () => undefined,
    });
    vnode.elm = comment;
    vnode.text = ' ';
    vnode.isComment = true;
    vnode.context = undefined;
    vnode.tag = undefined;
    vnode.data.directives = undefined;

    if (vnode.componentInstance) {
      vnode.componentInstance.$el = comment;
    }

    if (el.parentNode) {
      el.parentNode.replaceChild(comment, el);
    }
}